import { render, staticRenderFns } from "./panel-imgbox.vue?vue&type=template&id=bf770e20&scoped=true&"
import script from "./panel-imgbox.vue?vue&type=script&lang=js&"
export * from "./panel-imgbox.vue?vue&type=script&lang=js&"
import style0 from "./panel-imgbox.vue?vue&type=style&index=0&id=bf770e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf770e20",
  null
  
)

export default component.exports